import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ApiService } from '../api.service';
import * as moment from 'moment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  sorties:any;
  onTop:any;
  bestsellers:any;

  subs:any;


  homeImgs:any;


   responsiveOptions = [
      {
          breakpoint: '1024px',
          numVisible: 3,
          numScroll: 1
      },
      {
          breakpoint: '768px',
          numVisible: 2,
          numScroll: 1
      },
      {
          breakpoint: '560px',
          numVisible: 1,
          numScroll: 1
      }
  ];

  month = (new Date()).getMonth();

  news:any;

  constructor(private router:Router, public api:ApiService) { }

  ngOnInit(): void {
    this.api.currentUrl = this.router.url;
    this.subs = this.router.events.subscribe(event=>{
      if(event instanceof NavigationEnd){
        try {      
          if(event.url == event.urlAfterRedirects){
            if(event.url != "/login"){
              window.scroll(0,0);
              localStorage.setItem('EspaceProBlackrockPage',event.url);
            }
          }else{
            localStorage.removeItem('EspaceProBlackrockPage');
          }
          this.api.currentUrl = event.urlAfterRedirects;

          return true;
        } catch(e) {
          return false;
        }
      }
      return false;
    });

    this.sorties = this.api.games.filter(item=>{
      return item.out_date != null && item.out_date.indexOf(moment().format('YYYY-MM')) === 0; 
    });

    this.onTop = this.api.games.filter(item=>{
      return item.onTop; 
    });

    this.bestsellers = this.api.games.sort((a, b) => {
      return b.ventes.perDay - a.ventes.perDay;
    }).slice(0,4);

    if(!this.api.pro){
      this.api.get("site=getHomeImgs").then((res:any)=>{
        this.homeImgs = res.filter(item=>{
          return item.indexOf("export") === -1;
        });
      });
      this.api.post("site=getNewsPage",{page:1,nb_items:4}).then(res=>{
        this.news = res['data'];
        this.api.getJson("https://wordpress.blackrockgames.fr/wp-json/wp/v2/posts?categories=7&_embed").then((res2:any)=>{
          for(let row of res2){
            let item = {
              from: 'wp',
              img:row._embedded['wp:featuredmedia'] ? row._embedded['wp:featuredmedia']['0'].source_url: '',
              date_add: row.date,
              slug: row.slug,
              title: row.title.rendered
            }
            this.news = [...this.news, item];
          }
          this.news = this.news.sort((a,b)=> b.date_add.localeCompare(a.date_add)).slice(0,4);
        });
      });
    }


  }


  ngOnDestroy(){
    this.subs.unsubscribe();
  }
}
